import React from "react";
import { renderContentWithLineBreaks } from "../utils/renderContentWithLineBreaks";

interface CompostOption {
  img: string;
  label: string;
  description: string;
}

interface CompostOptionGridProps {
  content: string;
  options: CompostOption[];
}

const CompostOptionGrid: React.FC<CompostOptionGridProps> = ({
  options,
  content
}) => (
  <div className="w-full flex flex-col items-center">
    <p className="text-lg font-raleway text-center mb-6">
      {renderContentWithLineBreaks(content)}
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-5xl w-full">
      {options
        .filter(option => option.label.trim() !== '')
        .map((option) => (
          <div
            key={option.label}
            className="flex flex-col items-center bg-white rounded-xl shadow p-6"
          >
            {option.img && (
              <img
                src={option.img}
                alt={option.label}
                className="w-24 h-24 object-cover mb-4 rounded-full border-4 border-[#AE582D] bg-[#f5f5e6]"
              />
            )}
            <span className="text-[#1a3a1a] text-lg font-semibold font-raleway text-center mb-2">
              {option.label}
            </span>
            <p className="text-gray-700 text-center text-[16px] font-raleway">
              {option.description}
            </p>
          </div>
        ))}
    </div>
  </div>
);


export default CompostOptionGrid;